"use strict";

var _objectSpread = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useVideo = void 0;

var react_1 = require("react");

var CompositionManager_1 = require("./CompositionManager");

var useVideo = function useVideo() {
  var context = (0, react_1.useContext)(CompositionManager_1.CompositionManager);
  return (0, react_1.useMemo)(function () {
    var _a;

    var selected = context.compositions.find(function (c) {
      return c.id === context.currentComposition;
    });

    if (selected) {
      return _objectSpread(_objectSpread({}, selected), (_a = context.currentCompositionMetadata) !== null && _a !== void 0 ? _a : {});
    }

    return null;
  }, [context.compositions, context.currentComposition, context.currentCompositionMetadata]);
};

exports.useVideo = useVideo;